function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 13.2572C0 11.0001 0 9.8716 0.454005 8.89027C0.90801 7.90893 1.75628 7.20394 3.45281 5.79396L7.66854 2.29028C9.50569 0.763428 10.4243 0 11.5 0C12.5757 0 13.4943 0.763427 15.3315 2.29028L19.5472 5.79396C21.2437 7.20394 22.092 7.90893 22.546 8.89027C23 9.8716 23 11.0001 23 13.2572V16.6283C23 19.6319 23 21.1338 22.1018 22.0669C21.2036 23 19.7579 23 16.8667 23H6.13333C3.24205 23 1.79641 23 0.898206 22.0669C0 21.1338 0 19.6319 0 16.6283V13.2572Z",
  fill: "#6F62FF",
  fillOpacity: 0.1
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.4667 16.6283V13.2572C21.4667 10.8471 21.4312 10.1579 21.164 9.58031C20.8968 9.00275 20.4009 8.54342 18.5893 7.03784L14.3736 3.53416C13.4254 2.7461 12.8198 2.24633 12.3233 1.92712C11.8623 1.63074 11.6467 1.59294 11.5 1.59294C11.3533 1.59294 11.1377 1.63074 10.6767 1.92712C10.1802 2.24633 9.57461 2.7461 8.6264 3.53416L4.41067 7.03784C2.59911 8.54342 2.10321 9.00275 1.836 9.58031C1.5688 10.1579 1.53333 10.8471 1.53333 13.2572V16.6283C1.53333 18.1751 1.53659 19.175 1.63194 19.9118C1.72135 20.6027 1.86571 20.8192 1.98244 20.9405C2.09916 21.0618 2.30761 21.2117 2.97268 21.3046C3.68186 21.4037 4.64435 21.4071 6.13333 21.4071H16.8667C18.3557 21.4071 19.3181 21.4037 20.0273 21.3046C20.6924 21.2117 20.9008 21.0618 21.0176 20.9405C21.1343 20.8192 21.2786 20.6027 21.3681 19.9118C21.4634 19.175 21.4667 18.1751 21.4667 16.6283ZM0.454005 8.89027C0 9.8716 0 11.0001 0 13.2572V16.6283C0 19.6319 0 21.1338 0.898206 22.0669C1.79641 23 3.24205 23 6.13333 23H16.8667C19.7579 23 21.2036 23 22.1018 22.0669C23 21.1338 23 19.6319 23 16.6283V13.2572C23 11.0001 23 9.8716 22.546 8.89027C22.092 7.90894 21.2437 7.20394 19.5472 5.79396L15.3315 2.29028C13.4943 0.763427 12.5757 0 11.5 0C10.4243 0 9.50569 0.763428 7.66854 2.29028L3.45281 5.79396C1.75628 7.20394 0.90801 7.90894 0.454005 8.89027Z",
  fill: "#B7B0FF"
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: 8,
  y: 14,
  width: 7,
  height: 9,
  rx: 1,
  fill: "#B7B0FF"
});

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.e7a7e361.svg";
export { ForwardRef as ReactComponent };